import {
  Box,
  Button,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  Paper,
  Radio,
  RadioGroup,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useTheme,
} from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import * as sx from '../common/stylesInline/report_daily_branch'
import DropDownOA from '../common/dropDownOA'
import { Item } from '../common/snippets'
import LineinputV2 from '../common/lineinputV2'
import Datepicker from '../common/datePicker'
import { BranchRechargePendingCol, selectPaymentModeOpt } from '../common/constants'
import QRScanner from './QRScanner'
import { clickElement, focusElemnt, isEmpty, navigation1, navigation3 } from '../common/helper'
import moment from 'moment'
import { connect } from 'react-redux'
import { GetRechargePaymentModesListAll, getBranchListAndCityList, updateAlertError } from '../../store/common/common_action'
import { getBranchRecharge, getDynamicQRDetails } from '../../store/booking/booking_action'
import FileInput from '../common/fileInput'
import { uploadToS3 } from '../common/helper'
import SuccessAndErrorModal from '../common/SuccessAndErrorModal'
import Modal from '../common/modal'
import Lineinput from '../common/lineinput'
import { RAJESH_TRANSPORT, STA_COMPANY_ID } from '../../helper/companyIdhardcode'
import { useAtom } from 'jotai'
import { outStandingAmountAtom } from '../common/jotaiState/commonStateAtoms'
const BranchRecharge = (props) => {
  const { cargoBalance, companySettings } = props
  const {
    data,
    GetRechargePaymentModesListAll,
    getBranchRecharge,
    getBranchListAndCityList,
    updateAlertError,
    updateModal,
    getDynamicQRDetails,
  } = props
  const {
    common,
    branchAndUserMasterReducer: { BranchDetailsList },
  } = data
  const { loginData, RechargePaymentList } = common
  const { intCompanyID } = loginData
  const theme = useTheme()
  const { tableHeaderColor } = theme
  let labelAmt = ['', 'Amount Deposited', 'Cheque No.', 'Demand Draft No.', 'Transaction Ref No', 'Transaction Ref No', 'Amount Deposited']
  let labelDate = ['', 'Deposit Date', 'Cheque Date', 'Deposit Date', 'Transaction Date', 'Transaction Date', 'Deposit Date']
  const [selPaymentMode, setSelPaymentMode] = useState()
  const [showPending, setShowPending] = useState(false)
  const [showQRScanner, setShowQRScanner] = useState(true)
  const [showQRScanner2, setShowQRScanner2] = useState(false)

  const [pendingQRActive, setPendingQRAction] = useState('')
  const [paymentModeList, setPaymentModeList] = useState([])
  const [fileData, setFileData] = useState(null)
  const MaxFileSize = 10 * 1024 * 1024 //10MB
  const [resetFileInput, setResetFileInput] = useState(false)
  const [QRRechargeDeatils, setQRRechargeDetails] = useState({ rechargeAmt: 0, processingFees: 0, AmtToBePaid: 0 })
  const [OrderId, setOrderId] = useState(null)
  const [filters, setFilters] = useState({
    branchName: loginData?.strBranchName,
    currentBalance: 0,
    paymentMode: '',
    rechargeAmount: 0,
    processingFee: 0,
    amountToBePaid: 0,
    bankName: '',
    beneficiaryAccNo: '',
    instrumentNo: '',
    depositDate: moment(new Date()),
    instrumentDate: moment(new Date()),
  })
  const [DQRDetails, setDQRDetails] = useState({})
  const [isSuccess, setIsSuccess] = useState(false)
  const [disableinput, setDisableInput] = useState(false)
  const [QRData, setQRData] = useState(null)
  const [remainingTime, setRemainingTime] = useState(false)
  const initialTimeoutRef = useRef(null)
  const endTimeoutRef = useRef(null)
  const intervalIdRef = useRef(null)

  // const [isFocused, setIsFocused] = useState(false);
  // const handleFocus = () => setIsFocused(true);
  // const handleBlur = () => setIsFocused(false);
  const [pendingQRData, setPendingQRData] = useState([
    {
      branchName: 'Maven Operations Ahmedabad',
      RechargeDateTime: '12:00, 13-Jun-23',
      PaymentMode: 'QR',
      rechargeAmount: '10025',
      requestedBy: 'Kirtan Pandey',
      ShowOR: 1,
    },
    {
      branchName: 'Maven Operations Ahmedabad',
      RechargeDateTime: '12:00, 13-Jun-23',
      PaymentMode: 'QR',
      rechargeAmount: '10025',
      requestedBy: 'Kirtan Pandey',
      ShowOR: 1,
    },
    {
      branchName: 'Maven Operations Ahmedabad',
      RechargeDateTime: '12:00, 13-Jun-23',
      PaymentMode: 'QR',
      rechargeAmount: '10025',
      requestedBy: 'Kirtan Pandey',
      ShowOR: 1,
    },
    {
      branchName: 'Maven Operations Ahmedabad',
      RechargeDateTime: '12:00, 13-Jun-23',
      PaymentMode: 'QR',
      rechargeAmount: '10025',
      requestedBy: 'Kirtan Pandey',
      ShowOR: 1,
    },
  ])
  const [selectedOption, setSelectedOption] = useState('option1') // Default value

  const [outStandingAmount] = useAtom(outStandingAmountAtom)

  useEffect(() => {
    if (outStandingAmount) {
      setQRRechargeDetails((prev) => ({
        ...prev,
        rechargeAmt: outStandingAmount,
        processingFees: 0,
        amountToBePaid: outStandingAmount,
      }))
    }
  }, [outStandingAmount])

  const handleChange = (event) => {
    setSelectedOption(event.target.value)
  }
  const modalStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }
  useEffect(() => {
    focusElemnt('select_Payment_Mode')
  }, [])

  useEffect(() => {
    if (!isEmpty(loginData)) {
      const obj = {
        intUserID: 0,
        intCompanyID: loginData?.intCompanyID,
        intBranchID: loginData?.intBranchID,
        strBranchName: '',
        strBranchCode: '',
        intStateID: 0,
        intCityID: 0,
        intIsActive: -1,
      }
      getBranchListAndCityList(obj)
        .then((res) => {
          if (res.status === 'Success') {
            setFilters((prev) => ({
              ...prev,
              currentBalance: res?.Data?.Table?.[0]?.CargoBalance,
            }))
          } else {
            updateAlertError({ show: true, msg: res?.ErrMessage, nextId: '' })
          }
        })
        .catch((err) => {
          updateAlertError({ show: true, msg: err, nextId: '' })
        })
      GetRechargePaymentModesListAll()
      const body = { CompanyID: loginData?.intCompanyID }
      getDynamicQRDetails(body)
        .then((res) => {
          if (res?.status) {
            if (res?.Data?.Table?.length > 0) {
              setDQRDetails({ ...res?.Data?.Table?.[0], QRInstrumentDate: moment(new Date()).format('DD-MM-YYYY') })
              setDisableInput(false)
            } else {
              updateAlertError({
                show: true,
                msg: 'Dynamic QR Bank Account Details Not Found.\n Please Confirm QR Beneficiary Update Status',
                nextId: '',
              })
              setDisableInput(true)
            }
          } else {
            setDQRDetails({})
            // updateAlertError({ show: true, msg: res?.ErrMessage, nextId: '' });
          }
        })
        .catch((error) => {
          setDQRDetails({})
          updateAlertError({ show: true, msg: error, nextId: '' })
        })
    }
  }, [loginData])
  useEffect(() => {
    if (RechargePaymentList?.length > 0) {
      setPaymentModeList(RechargePaymentList)
      setSelPaymentMode(RechargePaymentList[0])
      setFilters((prev) => ({
        ...prev,
        paymentMode: RechargePaymentList[0],
        instrumentNo: 0,
      }))
    }
  }, [RechargePaymentList])
  useEffect(() => {
    if (fileData) {
      const allowedExtensions = ['.pdf', '.jpeg', '.jpg']
      const fileExtension = fileData.name.substring(fileData.name.lastIndexOf('.'))
      if (!allowedExtensions.includes(fileExtension.toLowerCase())) {
        updateAlertError({ show: true, msg: `Only PDF, JPEG Or JPG files are allowed`, nextId: '' })
        setFileData(null)
        setResetFileInput(!resetFileInput)
      } else if (fileData.size > MaxFileSize) {
        updateAlertError({ show: true, msg: `The size of the file being uploaded cannot be more than 10 MB`, nextId: '' })
        setFileData(null)
        setResetFileInput(!resetFileInput)
      } else {
        setResetFileInput(false)
      }
    }
  }, [fileData])

  const handleCloseIntervals = () => {
    clearInterval(intervalIdRef.current)
    clearTimeout(endTimeoutRef.current)
    clearTimeout(initialTimeoutRef.current)
    intervalIdRef.current = null
    endTimeoutRef.current = null
    initialTimeoutRef.current = null
  }
  const handleSaveQR = async () => {
    try {
      const url = fileData !== null ? await uploadToS3(fileData, 'Branch_Recharge_TransReceipt') : ''

      let obj = {
        intUserID: loginData?.intUserID,
        intCompanyID: loginData?.intCompanyID,
        intBranchID: loginData?.intBranchID,
        dcmAmount: QRRechargeDeatils?.rechargeAmt,
        intRechargePaymentModeID: 7,
        strBankName: DQRDetails?.BankName,
        strInstrumentNo: '',
        dtInstrumentDate: moment(DQRDetails?.QRInstrumentDate, 'DD-MM-YYYY').format('YYYY-MM-DD'),
        AmountDeposited: 0,
        DepoisteDate: filters?.depositDate,
        TransReceipt: url,
        intPartyID: 0,
      }

      const res = await getBranchRecharge(obj)
      if (res.status && res?.Data?.Table?.[0]?.hasOwnProperty('RechargeID')) {
        let rechargeID = res?.Data?.Table?.[0]?.RechargeID
        return rechargeID
      } else {
        return null
        updateAlertError({ show: true, msg: res?.ErrMessage, nextId: '' })
      }
    } catch (err) {
      updateAlertError({ show: true, msg: err, nextId: '' })
    }
    // }
  }
  const resetScreen = () => {
    // Logic to reset the screen
    handleCloseIntervals()
    debugger
    // dispatch(updateAlertError({ show: true, msg: `Recharge failed!. Please Try again. `, nextId: '' }))
    setQRRechargeDetails({
      rechargeAmt: outStandingAmount ? outStandingAmount : 0,
      processingFees: 0,
      amountToBePaid: outStandingAmount ? outStandingAmount : 0,
    })
    setQRData(null)
    setDisableInput(false)
    setRemainingTime(false)
    // Add any other reset logic here
  }
  const handleSave = async () => {
    if (filters?.rechargeAmount === 0) {
      updateAlertError({ show: true, msg: 'Please Enter The Recharge Amount', nextId: '' })
    } else if (filters?.bankName === '') {
      updateAlertError({ show: true, msg: 'Please Enter The Bank Name', nextId: '' })
    } else if (
      (selPaymentMode?.RechargePaymentModeID !== 1 || selPaymentMode?.RechargePaymentModeID !== 6) &&
      filters?.instrumentNo === ''
    ) {
      updateAlertError({ show: true, msg: `Please Enter The ${labelAmt[selPaymentMode?.RechargePaymentModeID]}`, nextId: 'labelAmt' })
    } else if (
      (selPaymentMode?.RechargePaymentModeID === 2 || selPaymentMode?.RechargePaymentModeID === 3) &&
      filters?.instrumentNo?.length < 6 &&
      loginData?.intCompanyID !== STA_COMPANY_ID
    ) {
      updateAlertError({
        show: true,
        msg: `${labelAmt[selPaymentMode?.RechargePaymentModeID]} Must Have Atleast 6 Characters`,
        nextId: 'labelAmt',
      })
    } else if (
      (selPaymentMode?.RechargePaymentModeID === 2 || selPaymentMode?.RechargePaymentModeID === 3) &&
      filters?.instrumentNo?.length > 6 &&
      loginData?.intCompanyID !== STA_COMPANY_ID
    ) {
      updateAlertError({
        show: true,
        msg: `${labelAmt[selPaymentMode?.RechargePaymentModeID]} Cannot Have More Than 6 Characters`,
        nextId: 'labelAmt',
      })
    } else if (
      selPaymentMode?.RechargePaymentModeID === 4 &&
      filters?.instrumentNo?.length < 12 &&
      loginData?.intCompanyID !== STA_COMPANY_ID
    ) {
      updateAlertError({
        show: true,
        msg: `${labelAmt[selPaymentMode?.RechargePaymentModeID]} Cannot Have Less Than 12 Characters`,
        nextId: 'labelAmt',
      })
    } else if (
      selPaymentMode?.RechargePaymentModeID === 5 &&
      filters?.instrumentNo?.length < 16 &&
      loginData?.intCompanyID !== STA_COMPANY_ID
    ) {
      updateAlertError({
        show: true,
        msg: `${labelAmt[selPaymentMode?.RechargePaymentModeID]} Cannot Have Less Than 16 Characters`,
        nextId: 'labelAmt',
      })
    } else if (companySettings?.IsUploadRchTxnReceipt === 1 && fileData === null) {
      updateAlertError({ show: true, msg: `Please Upload The Transaction Receipt`, nextId: '' })
    } else {
      try {
        const url = fileData !== null ? await uploadToS3(fileData, 'Branch_Recharge_TransReceipt') : ''

        let obj = {
          intUserID: loginData?.intUserID,
          intCompanyID: loginData?.intCompanyID,
          intBranchID: loginData?.intBranchID,
          dcmAmount: filters?.rechargeAmount,
          intRechargePaymentModeID: selPaymentMode?.RechargePaymentModeID,
          strBankName: filters?.bankName,
          strInstrumentNo: filters?.instrumentNo?.toString(),
          dtInstrumentDate: filters?.instrumentDate,
          AmountDeposited: 0,
          DepoisteDate: filters?.depositDate,
          TransReceipt: url,
          intPartyID: 0,
        }

        const res = await getBranchRecharge(obj)
        if (res.status && res?.Data?.Table?.[0]?.hasOwnProperty('RechargeID')) {
          setIsSuccess(true)
        } else {
          updateAlertError({ show: true, msg: res?.ErrMessage, nextId: '' })
        }
      } catch (err) {
        updateAlertError({ show: true, msg: err, nextId: '' })
      }
    }
  }
  return (
    <>
      <Box sx={{ padding: '16px 16px 0px 16px'}}>
      {/* <Box sx={{ padding: '16px 16px 0px 16px', display: outStandingAmount || intCompanyID===RAJESH_TRANSPORT ? 'none' : undefined }}>  */}
        <FormControl component="fieldset">
          <RadioGroup
            value={selectedOption}
            onChange={handleChange}
            aria-label="branch recharge options"
            name="branchRechargeOptions"
            sx={{
              display: 'flex',
              flexDirection: 'row', // Align items horizontally
            }}
          >
            <FormControlLabel
              value="option1"
              control={<Radio />}
              label={<Typography style={{ fontSize: '18px', fontWeight: 'bold' }}>Instant Recharge (UPI)</Typography>}
            />
            <FormControlLabel
              value="option2"
              control={<Radio />}
              label={<Typography style={{ fontSize: '18px', fontWeight: 'bold' }}>Raise Recharge Request</Typography>}
            />
          </RadioGroup>
        </FormControl>
      </Box>
      {selectedOption === 'option1' ? (
        <Box className="reportButton">
          <Grid container sx={{ padding: '12px' }}>
            <Grid item md={2.5}>
              <Item>
                <DropDownOA
                  id={'branch_name'}
                  label={'Branch Name'}
                  defaultvalue={filters?.branchName}
                  disabled={true}
                  onSelect={(val) => {}}
                />
              </Item>
            </Grid>
            <Grid item md={1.9}>
              <Item className={'input--wrapper btmSpaceNotRequired'}>
                <LineinputV2
                  label={'Current Balance'}
                  id={'current_balance'}
                  disabled={true}
                  value={filters?.currentBalance}
                  onBlur={(e) => {}}
                />
              </Item>
            </Grid>
            <Grid item md={1.9}>
              <Item className={'input--wrapper btmSpaceNotRequired'}>
                <LineinputV2 label={'Selected Payment Mode'} id={'paymentMode'} value={'UPI-QR Scan'} disabled={true} />
              </Item>
            </Grid>
            <Grid item md={1.9}>
              <Item className={'input--wrapper btmSpaceNotRequired'}>
                <LineinputV2 label={'Bank Name'} id={'bank_Name'} value={DQRDetails?.BankName} disabled={true} />
              </Item>
            </Grid>
            <Grid item md={1.9}>
              <Item className={'input--wrapper btmSpaceNotRequired'}>
                <LineinputV2 label={'Beneficiery Bank Account No'} id={'bank_Name'} value={DQRDetails?.AccountNumber} disabled={true} />
              </Item>
            </Grid>
            <Grid item md={1.9}>
              <Item className={'input--wrapper btmSpaceNotRequired'}>
                <LineinputV2
                  label={'Instrument Date'}
                  id={'instrument_date'}
                  value={DQRDetails?.QRInstrumentDate}
                  onBlur={(e) => {}}
                  disabled={true}
                />
              </Item>
            </Grid>
          </Grid>

          {showPending && (
            <Box sx={{ paddingX: '16px' }}>
              <Divider />
              <Typography sx={{ marginTop: '10px', fontWeight: 500, color: '#444' }} variant="h5" display="block">
                Pending QR Payment
              </Typography>

              <TableContainer
                className="scrollBlue"
                component={Paper}
                sx={{
                  maxHeight: '143px',
                  marginBottom: '5px',
                  marginTop: '10px',
                }}
              >
                <Table
                  stickyHeader
                  size="small"
                  aria-label="a dense table"
                  sx={{
                    '& .MuiTableCell-root': {
                      padding: '6px 8px !important',
                    },
                  }}
                >
                  <TableHead style={{ position: `sticky`, top: `0` }}>
                    <TableRow>
                      {BranchRechargePendingCol.map((col, index) => (
                        <TableCell
                          key={`THR-${index}`}
                          style={{
                            ...col.headerSx,
                            height: '36px',
                            backgroundColor: tableHeaderColor?.isHeadingColor,
                            color: '#444',
                            fontSize: '12px',
                            fontWeight: '600',
                            whiteSpace: 'pre-line',
                            lineHeight: 1.3,
                          }}
                        >
                          {col.headerName}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {pendingQRData.map((val, index) => {
                      return (
                        <TableRow key={`TD-${index}`}>
                          <TableCell
                            style={{
                              height: '36px',
                              textAlign: 'right',
                              fontSize: '12px',
                              minWidth: '60px',
                              color: '#444',
                              fontWeight: '500',
                            }}
                          >
                            {index + 1}
                          </TableCell>
                          <TableCell
                            style={{
                              height: '36px',
                              textAlign: 'left',
                              fontSize: '12px',
                              minWidth: '293px',
                              color: '#444',
                              fontWeight: '500',
                            }}
                          >
                            {val.branchName}
                          </TableCell>
                          <TableCell
                            style={{
                              height: '36px',
                              textAlign: 'left',
                              fontSize: '12px',
                              minWidth: '139px',
                              color: '#444',
                              fontWeight: '500',
                            }}
                          >
                            {val.RechargeDateTime}
                          </TableCell>
                          <TableCell
                            style={{
                              height: '36px',
                              textAlign: 'left',
                              fontSize: '12px',
                              minWidth: '169px',
                              color: '#444',
                              fontWeight: '500',
                            }}
                          >
                            {val.PaymentMode}
                          </TableCell>
                          <TableCell
                            style={{
                              height: '36px',
                              textAlign: 'right',
                              fontSize: '12px',
                              minWidth: '169px',
                              color: '#444',
                              fontWeight: '500',
                            }}
                          >
                            {val.rechargeAmount}
                          </TableCell>
                          <TableCell
                            style={{
                              height: '36px',
                              textAlign: 'left',
                              fontSize: '12px',
                              minWidth: '169px',
                              color: '#444',
                              fontWeight: '500',
                            }}
                          >
                            {val.requestedBy}
                          </TableCell>
                          <TableCell
                            style={{
                              height: '36px',
                              textAlign: 'left',
                              fontSize: '12px',
                              minWidth: '169px',
                              color: '#0086FF',
                              fontWeight: '500',
                              textDecoration: 'underline',
                              cursor: 'pointer',
                            }}
                          >
                            {pendingQRActive === index ? (
                              <span
                                onClick={() => {
                                  setShowQRScanner(false)
                                  setPendingQRAction('')
                                }}
                              >
                                Close
                              </span>
                            ) : (
                              <span
                                onClick={() => {
                                  setShowQRScanner(true)
                                  setPendingQRAction(index)
                                }}
                              >
                                Show
                              </span>
                            )}
                          </TableCell>
                        </TableRow>
                      )
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          )}

          {showQRScanner && (
            <Box sx={{ paddingX: '16px' }}>
              <QRScanner
                QRRechargeDeatils={QRRechargeDeatils}
                setQRRechargeDetails={setQRRechargeDetails}
                DQRDetails={DQRDetails}
                loginData={loginData}
                handleSaveQR={handleSaveQR}
                updateModal={updateModal}
                setShowQRScanner={setShowQRScanner}
                disableinput={disableinput}
                setDisableInput={setDisableInput}
                QRData={QRData}
                setQRData={setQRData}
                remainingTime={remainingTime}
                setRemainingTime={setRemainingTime}
                initialTimeoutRef={initialTimeoutRef}
                endTimeoutRef={endTimeoutRef}
                intervalIdRef={intervalIdRef}
                minimumAmount={outStandingAmount}
                handleClose={() => {
                  setShowQRScanner(false)
                  setPendingQRAction('')
                }}
              />
            </Box>
          )}
          {selPaymentMode?.RechargePaymentModeID !== 7 && (
            <>
              <Divider sx={{ marginTop: '16px', borderWidth: '2px' }} />
              <Box sx={{ display: 'flex', justifyContent: 'end', padding: '16px' }}>
                <Box sx={sx.itemsx}>
                  <Item className="disabled-wrapper">
                    <Button
                      id={'CANCEL'}
                      variant="outlined"
                      sx={{ width: '100%' }}
                      className="receiveitembtn"
                      onClick={() => {
                        resetScreen()
                      }}
                      onKeyDown={(e) => {
                        navigation1(e, 'RechargeBtn', 'choose_Receipt')
                      }}
                      //  disabled={selectedOption==='option1'}
                    >
                      CANCEL
                    </Button>
                  </Item>
                  <Item className="disabled-wrapper" style={{ display: outStandingAmount  || intCompanyID===RAJESH_TRANSPORT ? 'none' : 'block' }}>
                    <Button
                      variant="contained"
                      id="RechargeBtn"
                      style={{ ...sx.fullHeight, ...sx.novp, padding: '5px 20px' }}
                      className="btn btn-primary"
                      onClick={() => {
                        handleSave()
                      }}
                      onKeyDown={(e) => {
                        navigation1(e, 'select_Payment_Mode', 'CANCEL')
                      }}
                      disabled={selectedOption === 'option1'}
                    >
                      Recharge REQUEST
                    </Button>
                  </Item>
                </Box>
              </Box>
            </>
          )}
        </Box>
      ) : (
        <Box className="reportButton">
          <Grid container sx={{ padding: '12px' }}>
            <Grid item md={2.9}>
              <Item>
                <DropDownOA
                  id={'branch_name'}
                  label={'Branch Name'}
                  defaultvalue={filters?.branchName}
                  disabled={true}
                  onSelect={(val) => {}}
                />
              </Item>
            </Grid>
            <Grid item md={2.3}>
              <Item className={'input--wrapper btmSpaceNotRequired'}>
                <LineinputV2 label={'Current Balance'} id={'current_balance'} disabled={true} value={cargoBalance} onBlur={(e) => {}} />
              </Item>
            </Grid>
            <Grid item md={2.3}>
              <Item>
                <DropDownOA
                  id={'select_Payment_Mode'}
                  label={'Select Payment Mode'}
                  defaultvalue={selPaymentMode?.RechargePaymentModeName}
                  value={selPaymentMode?.RechargePaymentModeName}
                  data={paymentModeList || []}
                  idKey={`RechargePaymentModeID`}
                  dataKey={`RechargePaymentModeName`}
                  onSelect={(val) => {
                    setSelPaymentMode(val)
                    setFilters((prev) => ({
                      ...prev,
                      instrumentNo: val?.RechargePaymentModeID === 1 || val?.RechargePaymentModeID === 6 ? 0 : '',
                    }))
                    if (val?.RechargePaymentModeID !== 7) {
                      setShowPending(false)
                      setShowQRScanner(false)
                    }
                  }}
                  nextId={'recharge_Amount'}
                  prevId={'RechargeBtn'}
                />
              </Item>
            </Grid>
            <Grid item md={2.3}>
              <Item className={'input--wrapper btmSpaceNotRequired'}>
                {/* <LineinputV2
                                label={'Recharge Amount'}
                                id={'recharge_Amount'}
                                value={filters?.rechargeAmount}
                                onBlur={(e) => {
                                    setFilters((prev) => ({
                                        ...prev,
                                        rechargeAmount: Number(e.target.value.replace(/[^\d]/g, '')),
                                        amountToBePaid: Number(e.target.value.replace(/[^\d]/g, '')) + prev?.processingFee
                                    }))
                                }}
                                onKeyDown={(e) => {
                                    navigation1(e, selPaymentMode?.RechargePaymentModeID === 7 ? 'generateOR' : 'bank_Name', 'select_Payment_Mode')
                                }}
                            /> */}
                <Lineinput
                  label={'Recharge Amount'}
                  id={'recharge_Amount'}
                  value={filters?.rechargeAmount}
                  onChange={(e) => {
                    setFilters((prev) => ({
                      ...prev,
                      rechargeAmount: Number(e.target.value.replace(/[^\d]/g, '')),
                      amountToBePaid: Number(e.target.value.replace(/[^\d]/g, '')) + prev?.processingFee,
                    }))
                  }}
                  onKeyDown={(e) => {
                    navigation1(e, selPaymentMode?.RechargePaymentModeID === 7 ? 'generateOR' : 'bank_Name', 'select_Payment_Mode')
                  }}
                />
              </Item>
            </Grid>
            {/* <Grid item md={1.9}>
                        <Item className={'input--wrapper btmSpaceNotRequired'}>
                            <LineinputV2
                                label={'Processing Fees'}
                                id={'processing_Fees'}
                                value={filters?.processingFee}
                                onBlur={(e) => {

                                }}
                                disabled={true}
                            />
                        </Item>
                    </Grid> */}
            <Grid item md={2.2}>
              <Item className={'input--wrapper btmSpaceNotRequired'}>
                <LineinputV2
                  label={'Amount To be Paid'}
                  id={'amount_To_be_Paid'}
                  value={filters?.amountToBePaid}
                  onBlur={(e) => {}}
                  disabled={true}
                />
              </Item>
            </Grid>
            <Grid item md={2.9}>
              <Item className={'input--wrapper btmSpaceNotRequired'}>
                <LineinputV2
                  label={'Bank Name'}
                  id={'bank_Name'}
                  value={filters?.bankName}
                  onBlur={(e) => {
                    setFilters((prev) => ({
                      ...prev,
                      bankName: e.target.value,
                    }))
                  }}
                  disabled={selPaymentMode?.RechargePaymentModeID === 7}
                  onKeyDown={(e) => {
                    navigation1(e, 'labelAmt', 'recharge_Amount')
                  }}
                />
              </Item>
            </Grid>
            {selPaymentMode?.RechargePaymentModeID === 7 ? (
              <Grid item md={3.8}>
                <Item className={'input--wrapper btmSpaceNotRequired'}>
                  <LineinputV2
                    label={'Beneficiery Bank Account Number'}
                    id={'beneficiery_Bank'}
                    value={filters?.beneficiaryAccNo}
                    onBlur={(e) => {}}
                    disabled={selPaymentMode?.RechargePaymentModeID === 7}
                    onKeyDown={(e) => {
                      navigation1(e, 'generateOR', 'bank_Name')
                    }}
                  />
                </Item>
              </Grid>
            ) : (
              <>
                <Grid item md={2.3}>
                  <Item className={'input--wrapper btmSpaceNotRequired'}>
                    <Lineinput
                      label={labelAmt[selPaymentMode?.RechargePaymentModeID]}
                      id={'labelAmt'}
                      value={filters?.instrumentNo}
                      maxLength={
                        selPaymentMode?.RechargePaymentModeID === 2 || selPaymentMode?.RechargePaymentModeID === 3
                          ? 6
                          : selPaymentMode?.RechargePaymentModeID === 4
                          ? 22
                          : selPaymentMode?.RechargePaymentModeID === 5
                          ? 16
                          : 1
                      }
                      disabled={selPaymentMode?.RechargePaymentModeID === 1 || selPaymentMode?.RechargePaymentModeID === 6}
                      onChange={(e) => {
                        if (
                          selPaymentMode?.RechargePaymentModeID === 1 ||
                          selPaymentMode?.RechargePaymentModeID === 2 ||
                          selPaymentMode?.RechargePaymentModeID === 3
                        ) {
                          setFilters((prev) => ({
                            ...prev,
                            instrumentNo: Number(e.target.value.replace(/[^\d]/g, '')),
                          }))
                        } else if (selPaymentMode?.RechargePaymentModeID === 4 || selPaymentMode?.RechargePaymentModeID === 5) {
                          setFilters((prev) => ({
                            ...prev,
                            instrumentNo: e.target.value,
                          }))
                        }
                      }}
                      onKeyDown={(e) => {
                        navigation1(e, 'labelDate', 'bank_Name')
                      }}
                    />
                  </Item>
                </Grid>
                <Grid item md={2.3}>
                  <Item className="input--container bookingDatePicker">
                    <Datepicker
                      label={labelDate[selPaymentMode?.RechargePaymentModeID]}
                      width="100%"
                      name={'labelDate'}
                      id={'labelDate'}
                      value={filters?.depositDate}
                      dateChange={(date) => {
                        setFilters((prev) => ({
                          ...prev,
                          depositDate: date,
                        }))
                        focusElemnt('file-input-item')
                      }}
                    />
                  </Item>
                </Grid>
              </>
            )}
            <Grid item md={2.3}>
              <Item className="input--container bookingDatePicker">
                <Datepicker
                  label={'Instrument Date'}
                  width="100%"
                  name={'instrument_Date'}
                  value={filters?.instrumentDate}
                  id={'instrument_Date'}
                  statusChecked={true}
                  dateChange={(date) => {
                    setFilters((prev) => ({
                      ...prev,
                      instrumentDate: date,
                    }))
                  }}
                />
              </Item>
            </Grid>
            {selPaymentMode?.RechargePaymentModeID == 7 && (
              <>
                <Grid item md={1.7}>
                  <Item className="disabled-wrapper">
                    <Button
                      variant="outlined"
                      id="generateOR"
                      sx={{ width: '100%' }}
                      className="receiveitembtn"
                      onClick={() => {
                        setShowQRScanner(true)
                        setShowPending(false)
                      }}
                      onKeyDown={(e) => {
                        navigation3(e, 'PENDING', 'recharge_Amount', () => {})
                      }}
                    >
                      GENERATE QR
                    </Button>
                  </Item>
                </Grid>
                <Grid item md={2.1}>
                  <Item className="disabled-wrapper">
                    <Button
                      variant="contained"
                      id="PENDING"
                      style={{ ...sx.fullHeight, ...sx.novp, padding: '5px 20px' }}
                      className="btn btn-primary"
                      onClick={() => {
                        setShowPending(true)
                        setShowQRScanner(false)
                      }}
                      onKeyDown={(e) => {
                        navigation3(e, 'select_Payment_Mode', 'generateOR', () => {})
                      }}
                    >
                      PENDING QR PAYMENT
                    </Button>
                  </Item>
                </Grid>
              </>
            )}
          </Grid>
          {selPaymentMode?.RechargePaymentModeID !== 7 && (
            <>
              <Divider />
              <Box sx={{ display: 'flex', justifyContent: 'space-between', padding: '16px' }}>
                <Box sx={sx.itemsx}>
                  <Item>
                    <Box style={{ display: 'flex', alignItems: 'center', fontWeight: '500', fontSize: '14px', color: '#444' }}>
                      Upload Transaction Receipt :(Format : PDF,JPG)
                    </Box>
                  </Item>
                  <Item
                    sx={{ display: 'flex', flexDirection: 'column', marginTop: '14px !important', width: '300px' }}
                    className="disabled-wrapper"
                  >
                    <div
                      id={'file-input-item'}
                      tabIndex={0}
                      style={{
                        //     border: isFocused ? '2px solid red' : '2px solid transparent',
                        padding: '0px',
                        margin: '0px',
                        borderRadius: '6px',
                      }}
                      //     onFocus={handleFocus}
                      //     onBlur={handleBlur}
                      onKeyDown={(e) =>
                        navigation3(e, 'CANCEL', 'labelDate', () => {
                          clickElement('chooseFileInput')
                        })
                      }
                    >
                      <FileInput
                        id={'chooseFileInput'}
                        width={`300px`}
                        label={'Choose File'}
                        fileChange={setFileData}
                        accept={'.jpeg, .pdf'}
                        value={''}
                        reset={resetFileInput}
                        //    onKeyDown={(e) => navigation3(e, "CANCEL", 'labelDate', () => { })}
                      />
                    </div>
                    <span style={{ color: '#FE5200', fontSize: '12px' }}>* File must not exceed 10 MB</span>
                  </Item>
                </Box>
                <Box sx={sx.itemsx}>
                  <Item className="disabled-wrapper">
                    <Button
                      id={'CANCEL'}
                      variant="outlined"
                      sx={{ width: '100%' }}
                      className="receiveitembtn"
                      onClick={() => {
                        updateModal()
                      }}
                      onKeyDown={(e) => {
                        navigation1(e, 'RechargeBtn', 'choose_Receipt')
                      }}
                      //  disabled={selectedOption==='option1'}
                    >
                      CANCEL
                    </Button>
                  </Item>
                  <Item className="disabled-wrapper">
                    <Button
                      variant="contained"
                      id="RechargeBtn"
                      style={{ ...sx.fullHeight, ...sx.novp, padding: '5px 20px' }}
                      className="btn btn-primary"
                      onClick={() => {
                        handleSave()
                      }}
                      onKeyDown={(e) => {
                        navigation1(e, 'select_Payment_Mode', 'CANCEL')
                      }}
                      //  disabled={selectedOption==='option1'}
                    >
                      Recharge REQUEST
                    </Button>
                  </Item>
                </Box>
              </Box>
            </>
          )}
          {showPending && (
            <Box sx={{ paddingX: '16px' }}>
              <Divider />
              <Typography sx={{ marginTop: '10px', fontWeight: 500, color: '#444' }} variant="h5" display="block">
                Pending QR Payment
              </Typography>

              <TableContainer
                className="scrollBlue"
                component={Paper}
                sx={{
                  maxHeight: '143px',
                  marginBottom: '5px',
                  marginTop: '10px',
                }}
              >
                <Table
                  stickyHeader
                  size="small"
                  aria-label="a dense table"
                  sx={{
                    '& .MuiTableCell-root': {
                      padding: '6px 8px !important',
                    },
                  }}
                >
                  <TableHead style={{ position: `sticky`, top: `0` }}>
                    <TableRow>
                      {BranchRechargePendingCol.map((col, index) => (
                        <TableCell
                          key={`THR-${index}`}
                          style={{
                            ...col.headerSx,
                            height: '36px',
                            backgroundColor: tableHeaderColor?.isHeadingColor,
                            color: '#444',
                            fontSize: '12px',
                            fontWeight: '600',
                            whiteSpace: 'pre-line',
                            lineHeight: 1.3,
                          }}
                        >
                          {col.headerName}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {pendingQRData.map((val, index) => {
                      return (
                        <TableRow key={`TD-${index}`}>
                          <TableCell
                            style={{
                              height: '36px',
                              textAlign: 'right',
                              fontSize: '12px',
                              minWidth: '60px',
                              color: '#444',
                              fontWeight: '500',
                            }}
                          >
                            {index + 1}
                          </TableCell>
                          <TableCell
                            style={{
                              height: '36px',
                              textAlign: 'left',
                              fontSize: '12px',
                              minWidth: '293px',
                              color: '#444',
                              fontWeight: '500',
                            }}
                          >
                            {val.branchName}
                          </TableCell>
                          <TableCell
                            style={{
                              height: '36px',
                              textAlign: 'left',
                              fontSize: '12px',
                              minWidth: '139px',
                              color: '#444',
                              fontWeight: '500',
                            }}
                          >
                            {val.RechargeDateTime}
                          </TableCell>
                          <TableCell
                            style={{
                              height: '36px',
                              textAlign: 'left',
                              fontSize: '12px',
                              minWidth: '169px',
                              color: '#444',
                              fontWeight: '500',
                            }}
                          >
                            {val.PaymentMode}
                          </TableCell>
                          <TableCell
                            style={{
                              height: '36px',
                              textAlign: 'right',
                              fontSize: '12px',
                              minWidth: '169px',
                              color: '#444',
                              fontWeight: '500',
                            }}
                          >
                            {val.rechargeAmount}
                          </TableCell>
                          <TableCell
                            style={{
                              height: '36px',
                              textAlign: 'left',
                              fontSize: '12px',
                              minWidth: '169px',
                              color: '#444',
                              fontWeight: '500',
                            }}
                          >
                            {val.requestedBy}
                          </TableCell>
                          <TableCell
                            style={{
                              height: '36px',
                              textAlign: 'left',
                              fontSize: '12px',
                              minWidth: '169px',
                              color: '#0086FF',
                              fontWeight: '500',
                              textDecoration: 'underline',
                              cursor: 'pointer',
                            }}
                          >
                            {pendingQRActive === index ? (
                              <span
                                onClick={() => {
                                  setShowQRScanner(false)
                                  setPendingQRAction('')
                                }}
                              >
                                Close
                              </span>
                            ) : (
                              <span
                                onClick={() => {
                                  setShowQRScanner(true)
                                  setPendingQRAction(index)
                                }}
                              >
                                Show
                              </span>
                            )}
                          </TableCell>
                        </TableRow>
                      )
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          )}

          {showQRScanner2 && (
            <Box sx={{ paddingX: '16px' }}>
              <Divider />
              <QRScanner
                handleClose={() => {
                  setShowQRScanner2(false)
                  setPendingQRAction('')
                }}
              />
            </Box>
          )}
        </Box>
      )}

      <SuccessAndErrorModal
        handleClose={() => {
          setIsSuccess(false)
          updateModal()
          focusElemnt('')
        }}
        open={isSuccess}
        title={`Recharge Request Submitted\nSuccessfully of Rs ${filters?.amountToBePaid}`}
        modalStyle={modalStyle}
      />
      {/* </Modal> */}
    </>
  )
}
const mapStateToProps = (data) => ({ data })

const mapDispatchToProps = {
  GetRechargePaymentModesListAll,
  getBranchRecharge,
  getBranchListAndCityList,
  updateAlertError,
  getDynamicQRDetails,
}
export default connect(mapStateToProps, mapDispatchToProps)(BranchRecharge)
